window.StockCubeVR = {
    schema: {
        ...window.StockCubeCore.schemaBase,
    },

    platformConfig: {
        platform: 'vr',
        fontSize: 0.012,
        labelYOffset: 0.03,
        usableHeight: 0.35,
        sectorLabelStyle: {
            fontSize: 0.02,
            outlineWidth: '15%',
            outlineColor: '#000000',
            margin: 0.15,
            yOffset: -0.08,
            circleRadius: 0.01,
            localYOffset: 0.01,
            localZOffset: 0.02,
        },
        primaryLabelStyle: {
            themeAware: true,
            color: 'white',
            outlineColor: '#18181b',
            outlineWidth: '40%',
            outlineBlur: '40%',
            strokeWidth: null,
            fillOpacity: null,
            depthOffset: '1',
        },
    },

    updateSelectorVisibility: function (forceHide = false) {
        window.StockCubeCore.updateSelectorVisibility.call(this, forceHide);

        const isSipDataSource = ['sip', 'sip-sec', 'dividend', 'dividend-sec'].includes(this.data.dataSource);
        const intervalControlElement = document.querySelector('#interval-control');
        const timelineElement = document.querySelector('#timeline');
        const sipFilters = document.querySelector('#sip-filters');
        if (sipFilters) {
            sipFilters.setAttribute('visible', isSipDataSource);
            sipFilters.setAttribute('position', !isSipDataSource ? '-0.7 -10.3 0.01' : '-0.5 -0.56 0.01');
        }
        if (intervalControlElement) intervalControlElement.setAttribute('visible', !isSipDataSource);
        if (timelineElement) {
            timelineElement.setAttribute('visible', !isSipDataSource);
            if (isSipDataSource) {
                timelineElement.setAttribute('position', '-0.7 -10.3 0');
            } else if (this.data.dataSource === 'watchlist-reports') {
                timelineElement.setAttribute('position', '-0.370 -0.430 0');
            } else {
                timelineElement.setAttribute('position', '-0.5 -0.56 0.01');
            }
        }
    },

    afterInit: function () {
        this.setupThemeListener();
        const isLight = document.body.classList.contains('light') || document.body.classList.contains('cb-light');
        this.updateLabelsTheme(isLight);
    },

    setupThemeListener: function () {
        try {
            this._onThemeChanged = (e) => {
                if (!e || !e.detail) return;
                const newTheme = e.detail.themeMode;
                if (newTheme) {
                    const isLight = newTheme === 'Light';
                    this.updateLabelsTheme(isLight);
                }
            };
            this.el.sceneEl.addEventListener('theme-changed', this._onThemeChanged);

            this._themeObserver = new MutationObserver((mutations) => {
                for (const mutation of mutations) {
                    if (mutation.attributeName === 'class') {
                        const isLight = document.body.classList.contains('light') || document.body.classList.contains('cb-light');
                        this.updateLabelsTheme(isLight);
                    }
                }
            });
            this._themeObserver.observe(document.body, { attributes: true });

        } catch (err) {
            console.warn('[Stock Visualizer VR] Failed to attach theme listener', err);
        }
    },

    updateLabelsTheme: function (isLight) {
        const labelColor = isLight ? "#111827" : "#FFFFFF";
        const outlineColor = isLight ? "#FFFFFF" : "#000000";

        if (this.sectorLabels) {
            for (const [sectorId, labelGroup] of this.sectorLabels) {
                const textEl = labelGroup.querySelector('a-troika-text');
                if (textEl) {
                    textEl.setAttribute('color', labelColor);
                    textEl.setAttribute('outline-color', outlineColor);
                }
            }
        }

        if (this.stockBars) {
            for (const [ticker, barInfo] of this.stockBars) {
                if (barInfo && barInfo.primaryLabel) {
                    barInfo.primaryLabel.setAttribute('color', labelColor);
                    barInfo.primaryLabel.setAttribute('outline-color', outlineColor);
                }
            }
        }

        const stockBanner = document.querySelector('#stock-banner');
        if (stockBanner) {
            stockBanner.setAttribute('color', labelColor);
            stockBanner.setAttribute('outline-color', outlineColor);
        }

        const timeDate = document.querySelector('#current-time-date');
        if (timeDate) {
            timeDate.setAttribute('color', labelColor);
            timeDate.setAttribute('outline-color', outlineColor);
        }
    },

};

AFRAME.registerComponent('stock-cube-visualizer', {
    ...window.StockCubeCore,
    ...window.VRMarketMapLayout,
    ...window.StockCubeVR,
    
    init: async function() {
        if (window.StockCubeCore.init) await window.StockCubeCore.init.call(this);
        
        if (window.AutoRefreshScheduler && !this.mainChartScheduler) {
            this.mainChartScheduler = new window.AutoRefreshScheduler({
                name: 'MainChartVR',
                scheduleType: 'fixed-30',
                onRefresh: () => {
                    const isExcluded = ['sip', 'dividend', 'sip-sec', 'dividend-sec'].includes(this.data.dataSource);
                    
                    if (this.data.dataSource === 'watchlist-reports') {
                        if (window.WatchlistApp && window.WatchlistApp.Manager && window.WatchlistApp.State) {
                            const state = window.WatchlistApp.State;
                            if (state.currentUserId && state.currentWatchlistId) {
                                window.WatchlistApp.Manager.loadWatchlistData(state.currentUserId, state.currentWatchlistId, [], null, true, false);
                            }
                        }
                    } else if (!isExcluded) {
                        this.fetchStockData();
                    }
                }
            });
            this.mainChartScheduler.start();
        }
    },
    
    remove: function() {
        if (window.StockCubeCore.remove) window.StockCubeCore.remove.call(this);
        if (this.mainChartScheduler) {
            this.mainChartScheduler.stop();
        }
    }
});
